import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const AudioWidget = () => {

    function handlAudioClick(){
        (window as any).functions?.mediaLibrary?.('Audio')
    }

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.AUDIO} onClick={handlAudioClick} />
        </div>
    )
}
export default AudioWidget;